<template>
  <div class="w-100 h-100">
    <h1 class="display-2">{{title}}</h1>

    <div>
      <b-button-group size="lg">
        <b-button :variant="read === 1 ? 'primary' : 'secondary'" @click="switchRead(1)">Read 1</b-button>
        <b-button :variant="read === 2 ? 'primary' : 'secondary'" @click="switchRead(2)">Read 2</b-button>
        <b-button :variant="read === 3 ? 'primary' : 'secondary'" @click="switchRead(3)">Read 3</b-button>
      </b-button-group>
    </div>

    <b-container fluid>
      <b-row>
        <b-col md="12" lg="8" xl="6">
          <b-container fluid class="bg-white rounded mt-3 py-2 float-left">
            <b-row class="border-bottom mx-1">
              <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                <label>Asx Para:</label>
              </b-col>
              <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                <b-form-input v-model="form.asx_para"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="border-bottom mx-1">
              <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                <label>RBC Density Base:</label>
              </b-col>
              <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                <b-form-input v-model="form.rbc_density_base"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="border-bottom mx-1">
              <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                <label>RBC Density Exponent:</label>
              </b-col>
              <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                <b-form-input v-model="form.rbc_density_exponent"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="border-bottom mx-1">
              <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                <label>Para Density:</label>
              </b-col>
              <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                <b-form-input v-model="form.para_density"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mx-1">
              <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1"></b-col>
              <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                <b-button @click="save()" size="lg" variant="success" class="w-100">Save</b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import {
//     HTTP
// } from '@/utilities/http-common';
// import HandleErrors from '@/utilities/handle-errors';

// import BaseTemplate from '@/layouts/BaseTemplate.vue'
import { mapState, mapGetters, mapActions } from "vuex";
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [
    // BaseTemplate,
    DashboardBaseTemplate
  ],
  components: {},
  props: {
    prop: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: function() {
    return {
      title: "Thin Film Counting",
      form: {
        asx_para: null,
        rbc_density_base: null,
        rbc_density_exponent: null,
        para_density: null
      },
      read: 1,
      entry: null
    };
  },
  computed: {
    ...mapState("sample", ["sample"]),
    ...mapGetters("smicroscopy", ["getByIndex"])
  },
  created: function() {},
  mounted: function() {
    let index = parseInt(this.$route.params.index);
    let read = this.$route.query.read ? parseInt(this.$route.query.read) : 1;
    this.entry = this.getByIndex(index);
    this.switchRead(read);
  },
  methods: {
    ...mapActions("smicroscopy", ["updateEntry"]),
    get: function() {
      // HTTP.get('/').then((response) => {
      //     let something = response.data;
      // }).catch((error) => {
      //     HandleErrors.HandleErrors(error);
      // });
    },
    find: function() {},
    patch: function() {},
    delete: function() {},
    save: function() {
      let payload = { index: parseInt(this.$route.params.index) };
      payload["asx_para_" + this.read] = this.form.asx_para;
      payload["rbc_density_base_" + this.read] = this.form.rbc_density_base;
      payload[
        "rbc_density_exponent_" + this.read
      ] = this.form.rbc_density_exponent;
      payload["para_density_" + this.read] = this.form.para_density;
      this.updateEntry(payload);
    },
    switchRead: function(read) {
      this.read = read;
      this.form.asx_para = this.entry["asx_para_" + this.read];
      this.form.rbc_density_base = this.entry["rbc_density_base_" + this.read];
      this.form.rbc_density_exponent = this.entry[
        "rbc_density_exponent_" + this.read
      ];
      this.form.para_density = this.entry["para_density_" + this.read];
    }
  }
};
</script>
